<sc-padding>
  <sc-flex>
    <sc-action-icon mat-icon-button (click)="newVisitReservation()" iconClass="fa-plus" large
      [matTooltip]="'Voranmeldung anmelden' | translate: ['tmc.visitreservation.action.new.tooltip', translationService.language, translationService.revision]">
    </sc-action-icon>
    <sc-content-spacer></sc-content-spacer>
    <sc-action-icon mat-icon-button (click)="editVisitReservation()" iconClass="fa-edit" large
      [matTooltip]="'Voranmeldung bearbeiten' | translate: ['tmc.visitreservation.action.edit.tooltip', translationService.language, translationService.revision]"
      [disabled]="!isEditAllowed">
    </sc-action-icon>
    <sc-content-spacer></sc-content-spacer>
    <sc-action-icon mat-icon-button (click)="deleteVisitReservation()" iconClass="fa-trash" large
      [matTooltip]="'Voranmeldung löschen' | translate: ['tmc.visitreservation.action.delete.tooltip', translationService.language, translationService.revision]"
      [disabled]="!isDeleteAllowed">
    </sc-action-icon>
    <sc-content-spacer></sc-content-spacer>
    <sc-action-icon mat-icon-button (click)="resendInvitation()" iconClass="fa-envelope" large
      [matTooltip]="'Einladungs-E-Mail erneut versenden' | translate: ['tmc.visitreservation.action.resendInvitationMail.tooltip', translationService.language]"
      [disabled]="!resendInvitationEnabled">
    </sc-action-icon>
  </sc-flex>
</sc-padding>
